const $         = require('jquery');
const { icon }  = require('@fortawesome/fontawesome-svg-core');
const evtbus    = require('../evtbus');

const faIconOpts = { classes: ['fa-icon icon-h-14'] };
const fa = {
  externalLinkSquare: require('@fortawesome/pro-light-svg-icons/faExternalLinkSquare').definition
};

function figure({ figures, imgsrc = 'thumb' }) {
  function trimSc(str) {
    str = str.replace(/^([\s\:\.])+/g, '');
    str = str.replace(/([\s\:])+$/g, '');
    return str;
  }

  function figureDescription(description) {
    const idx = description.indexOf(':');
    if (idx == -1) return description;
    const parts = [
      trimSc(description.substr(0, idx)),
      trimSc(description.substr(idx + 1))
    ];
    return `<b>${parts[0]} | </b>${parts[1]}`;
  }

  const elem = $(`
    <div>
      ${figures.map((figure, index) => {
        return `
          <div class="figure" idx="${index}">
            <div class="view-figure">
              <img class="thumb" draggable="false" src="${figure[imgsrc]}" alt/>
              <div class="launch">
                ${icon(fa.externalLinkSquare, faIconOpts).html}
                <span>View</span>
              </div>
            </div>
            <span class="description">
              ${figureDescription(figure.caption)}
            </span>
          </div>`;
      }).join('')}
    </div>
  `);

  elem.find('.figure').click(function(e) {
    e.preventDefault();
    const idx = parseInt($(this).attr('idx'));
    evtbus.trigger('open-figure', [idx, figures]);
  }).each(function(idx) {
    const thumb = figures[idx].thumb;
    if (thumb) {
      const img = new Image();
      img.onload = () => $(this).attr('loaded', 'true');
      img.onerror = () => $(this).attr('loaded', 'false');
      img.src = thumb;
    } else {
      $(this).attr('loaded', 'false');
    }
  });

  return elem;
}

module.exports = figure;
